import React from 'react';
import LatexHTMLRenderer from 'src/app/components/LatexHTMLRenderer/LatexHTMLRenderer';
import styles from 'src/app/components/TutorChatBubble/MultipleInput/MultipleInput.module.scss';

type SingleInputPropType = {
  isIntroMessage?: boolean;
  content: string;
  isLastItem?: boolean;
};

function SingleInput(props: SingleInputPropType) {
  const { content, isIntroMessage, isLastItem } = props;

  return (
    <>
      <div
        className={`${styles.customizedScroll} overflow-x-auto overflow-y-hidden text-main text-body-small ${isIntroMessage ? 'w-full' : ''}`}
        // aria-live={ isLastItem ? "assertive" : 'off' }
        // aria-atomic={isLastItem ? "true" : 'false'}
      >
        <div className={`${isIntroMessage ? 'flex flex-col w-full overflow' : ''}`}>
          <LatexHTMLRenderer content={content} size='small' />
        </div>
      </div>
    </>
  );
}

export default SingleInput;
